module.exports = __webpack_public_path__ + "img/pk.b67f80e0.svg";